<template>
    <div>
      <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">Tenant Management </span>
      </div>
        <div class="text-right ml-auto">
        <!-- <kendo-button @click="addTenant">Add New Tenant</kendo-button> -->
        <kendo-button class="k-button k-primary ml-2"  type="button" icon="add" @click="addTenant">Add New Tenant</kendo-button>
      </div>
    </div>
    <div class="page-body">
      <Grid 
      ref="grid" 
      :style="{height: '500px'}" 
      :data-items="gridData" 
      :columns="columns" 
      :sortable="true" 
      :sort="sort" 
      :pageable="true" 
      :skip="skip" 
      :take="take" 
      :total="total" 
      :page-size="pageSize" 
      :resizable="true"
      @pagechange="pageChangeHandler"
      @edit="edit" 
      @view="view"
      @remove="remove" 
      @confirm="changeActivation"
      @sortchange="sortChangeHandler">
          <grid-toolbar>
              <div class="d-flex">
                  <div class="mr-auto">
                      <!-- <h5>User Details</h5> -->
                  </div>
                  <div class="ml-auto">
                      <k-input  v-model="search" placeholder="Search" @input="searchEnterClicked($event)" ></k-input>
                      
                      <!--<button class="k-button ml-2">Copy</button>
                      <button class="k-button ml-2">Print</button>-->
                  </div>
              </div>
          </grid-toolbar>
      </Grid>
      <!-- <tenant-listing :tenants="tenantsData"></tenant-listing> -->
    </div>
    <kendo-dialog
      ref="bulkActiondialog"
      :modal="true"
      :width="300"
      :title="'Confirm Save Request'"
      :visible="false"
    >
      Are you sure that you want to proceed?
      <kendo-dialog-action :text="'OK'" :action="okActiveAction"></kendo-dialog-action>
      <kendo-dialog-action :text="'Cancel'" :primary="true" :action="cancelAction"></kendo-dialog-action>
    </kendo-dialog>
    </div>  
</template>

<script>
import CommandCell from "@/components/CommandCellTemplateWithView";
import ToggleButton from "@/components/ToggleButton"
import { orderBy } from "@progress/kendo-data-query";
import { mapState, createNamespacedHelpers } from "vuex";
const {  mapActions } = createNamespacedHelpers("onboarding");
export default {
  data: function() {
    return {
      columns: [
        { field: 'name', title: "Name", width: "150px" },
        { field: 'subDomain', title: "Sub Domain", width: "150px" },
        { field: 'website', title: "Website", width: "150px" },
        { field: 'contactPerson', title: "Contact Person", width: "150px"},
        { field: 'contactNo', title: "Contact No", width: "150px" },
        { field: 'emailId', title: "Email Id", width: "180px" },
        { field: 'subscription', title: "Subscription", width: "100px" },
        { cell: ToggleButton, field: 'activated', title: "Activated", width: "100px" },
        { title: "Action", cell: CommandCell, locked: true, filterable: false, width: "120px"}
      ],
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      search: "",
      sort: [{ field: "name", dir: "asc" }],
      gridData:[],
      tenantInfo:{}
    }
  },
  methods: {
    ...mapActions(["activation", "cancelation"]),
    addTenant: function() {
      this.$store.dispatch("onboarding/resetState");
      this.$router.push("/add-tenant");
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    edit(item) {
      this.$store.dispatch("onboarding/loadTenant", item.dataItem).then(() => {
        this.$router.push("/add-tenant");
      });
    },
    remove: function(item) {
      return this.$store.dispatch("onboarding/removeTenant", item.dataItem).then(() => {
        // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
      });
      // .catch(notifyApiError);
    },
    view(item) {
      return this.$store.dispatch("onboarding/loadTenant", item.dataItem).then(() => {
        this.$router.push("tenant-management/view-tenant/" + item.dataItem.id);
      });
    },
    async getDataOnload() {
      await this.$store.dispatch("loadTenants");
    },
    searchEnterClicked(e) {
      let gridData = this.tenants;
      if(e.value) {
      // this.tenantsData = gridData.filter(item =>item.name.toLowerCase().includes(event.value.toLowerCase()));
      this.gridData = gridData.filter(function(obj) {
        for(let key in obj) {
          if(obj[key] && obj[key] != null) {
          if(String(obj[key]).includes(e.value.toLowerCase())){
            return obj;
            }
          }
        }
        });
      } else {
      this.gridData = gridData;
      }
    },
    changeActivation(e) {
      this.$refs.bulkActiondialog.kendoWidget().open();
      this.tenantInfo = e.dataItem;
    },
    okActiveAction() {
      console.log(this.tenantInfo)
      this.activation(this.tenantInfo);
    },
    cancelAction() {
      this.cancelation(this.tenantInfo);
    },
  },
  computed: {
    ...mapState(["tenants"]),
      total() {
      return this.$store.state.tenants ? this.$store.state.tenants.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.tenants.slice(this.skip, this.take + this.skip),this.sort);
      }
    },
  },
  watch:{
    tenants :{
      handler() {
        this.gridData =  orderBy(
          this.tenants.slice(this.skip, this.take + this.skip),this.sort);
      },
      immediate: true
    },
    items(){
      this.gridData =  orderBy(
          this.tenants.slice(this.skip, this.take + this.skip),this.sort);
    }
  },
  async mounted() {
    await this.getDataOnload()
    this.gridData =  orderBy(
          this.tenants.slice(this.skip, this.take + this.skip),this.sort);
  },
  components: { }
};
</script>